import { Modelo } from '@ext/index';
import * as Types from './Bulto.types';
import moment, { Moment } from 'moment';

export class IBulto extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: string = '';
    public Guia: number = 0;
    public Numero: number = 0;
    public Tipo: number = 0;
    public Peso: number = 0;
    public PesoSistema: number = 0;
    public PesoSalida: number = 0;


    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
        json.guia = this.Guia;
        json.numero = this.Numero;
        json.tipo = this.Tipo;
        json.peso = this.Peso;
        json.peso_sistema = this.PesoSistema;
        json.peso_salida = this.PesoSalida;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Guia = !this.Json.guia ? 0 : this.Json.guia;
        this.Numero = !this.Json.numero ? 0 : this.Json.numero;
        this.Tipo = !this.Json.tipo ? 0 : this.Json.tipo;
        this.Peso = !this.Json.peso ? 0 : this.Json.peso;
        this.PesoSistema = !this.Json.peso_sistema ? 0 : this.Json.peso_sistema;
        this.PesoSalida = !this.Json.peso_salida ? 0 : this.Json.peso_salida;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IBulto ) {
        this.Model = Model;
    }

    public Model: IBulto;
}